/** members group: memberships and permission grants (identity) (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const membersPermissions = ['members:read', 'members:manage', 'members:grant'] as const;

export type MembersPermission = (typeof membersPermissions)[number];
